<div class="loginPage alignMiddle">
  <div class="loginLeft">
    <!-- <div class="LinkSolucionesLogo">
      <img src="/assets/img/marca hostel HR.png" />
    </div> -->

    <div class="loginContainer">
      <h3 *ngIf="titulo && titulo !== ''" class="mb-3">{{titulo}}</h3>
      <div class="loginBox">

        <ng-content></ng-content>
      </div>

      <div class="footerText">
        <span> &copy;{{copyrightDate | date: 'yyyy'}} Link Soluciones. Todos los derechos reservados. </span>
      </div>
    </div>
  </div>

  <!-- <div class="loginRight"></div> -->
</div>
